// extracted by mini-css-extract-plugin
export default {"loadImg":"asyncImage_loadImg__BcSpP"};